export enum eMatchedQueryValue {
  MATCHED = 'MATCHED',
  UNMATCHED = 'UNMATCHED',
  MISMATCHED = 'MISMATCHED',
  ALL = 'ALL',
}
